import IPadImgV5 from '@components/imageModules/v5/iPadImgV5'
import { GATSBYIMGLOADING } from '@et/types/Enums'
import { IGatsbyImageDataObject } from '@et/types/Gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
import { twMerge } from 'tailwind-merge'

interface Props {
  screen: IGatsbyImageDataObject
  backgroundImage: IGatsbyImageDataObject
  ipadImgCss?: string
  backgroundImgCss?: string
  applePencil?: boolean
  containerCss?: string
}

function ProcreatePatternsHero(props: Props) {
  const { screen, backgroundImage, ipadImgCss, backgroundImgCss, containerCss, applePencil = false } = props

  return (
    <div className={twMerge('h-[449px] md:h-[729px] lg:h-[719px] xl:h-[900px] w-full relative', containerCss)}>

      {/* PATTERNS IMAGE */}
      <div className={twMerge('w-[810px] absolute top-0 left-1/2 -translate-x-1/2 z-1 md:w-[1310px] xl:w-[1720px]', backgroundImgCss)}>
        <GatsbyImage
          alt={'Every Tuesday Apple Pencil for the iPad Pro'}
          image={backgroundImage.gatsbyImageData}
          loading={GATSBYIMGLOADING.EAGeR}
        />
        {/* <img
          src={backgroundImage.gatsbyImageData.images?.fallback?.src}
          srcSet={backgroundImage.gatsbyImageData.images?.fallback?.srcSet}
          alt={`Procreate Patterns: The best way to make seamless patterns in procreate`} /> */}
      </div>

      {/* IPAD IMAGE */}
      <div className={twMerge('max-w-[600px] mx-auto w-full absolute top-[41%] -translate-y-1/2  -translate-x-1/2 left-1/2 xl:max-w-[800px] z-2 -rotate-[4deg]', ipadImgCss)}>
        <IPadImgV5
          lazy={false}
          priority={true}
          showApplePencil={applePencil}
          screen={{
            img: screen,
            alt: 'Procreate Patterns iPad Pro'
          }}
        />

        {/* {applePencil && <div className='absolute -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2'>
          <ApplePencil />
        </div>} */}
      </div>
    </div>
  )
}

export default ProcreatePatternsHero
